import React from "react";
import { Button, Modal } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { mobileVal, nameValidation } from "../CommonMethhods/CommonMethods";

function IBAAgentModalCommon({ modalHide, setModalHide, editType, editData }) {
  console.log(modalHide, setModalHide, editType, "setModalHide");
  // const schema = yup.object().shape({
  //   userId: yup.string().required("User ID is required"),
  //   phNumber:  yup.string().required("Mobile Number is a required field.").matches( /^[6-9]{1}[0-9]{9}$/,"Please enter valid number,Initial digit must range from 6 -9 "),
  //   password: yup.string().required("Please enter a valid password"),
  //   teamlead: yup.string().required("Name of Team Lead is required"),
  // });

  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm({
  //   mode: "onChange",
  //   resolver: yupResolver(schema),
  // });

  // const onFormSubmit = (values) => {
  //   console.log(values, "values");
  //   setModalHide(false); 
  // };
  let schema;
  if (editType === "profile") {
    schema = yup.object().shape({
      userId: yup.string().required("User ID is required"),
      phNumber: yup.string().required("Mobile Number is a required field.").matches(/^[6-9]{1}[0-9]{9}$/, "Please enter valid number,Initial digit must range from 6 -9 "),
      password: yup.string().required("Please enter a valid password"),
      teamlead: yup.string().required("Name of Team Lead is required"),
    });
  } else if (editType === "personal") {
    schema = yup.object().shape({
      fullName: yup.string().required("Full Name is required"),
      dob: yup.string().required("DOB is required"),
      gender: yup.string().required("Gender is required"),
      address: yup.string().required("Address is required"),
      aadhaar: yup.string().required("Aadhaar is required"),
      pan: yup.string().required("PAN is required"),
    });
  } else if (editType === "bank") {
    schema = yup.object().shape({
      accountNumber: yup.string().required("Account Number is required"),
      ifscCode: yup.string().required("IFSC Code is required"),
      micr: yup.string().required("MICR is required"),
      branchName: yup.string().required("Branch Name is required"),
      branchAddress: yup.string().required("Branch Address is required"),
      bankaddress:yup.string().required("Bank Address is required")
    });
  }

  const { register, handleSubmit, formState: { errors } } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: editData
  });

  const onFormSubmit = (values) => {
    console.log(values, "values");
    setModalHide(false);
  };


  return (
    <div>
      <Modal
        show={modalHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="freeze-unfreeze-modal"
      >
        <Modal.Body>
          <button
            type="button"
            onClick={() => setModalHide(false)}
            className="btn-close agent-close"
            aria-label="Close"
          >
            <span className="icon-close"></span>
          </button>
          <form className="form-box" onSubmit={handleSubmit(onFormSubmit)}>
            <div className="iba-modal">
              <div className="agent-title">
                {/* <span className="section-title-iba">Profile</span> */}
                <span className="section-title-iba">{editType === "personal" ? "Personal Details" : editType === "bank" ? "Bank Details" : "Profile"}</span>
              </div>
              <div className="edit-input">
                {editType === "profile" && (

                  <>
                    <div className="input-left">
                      <div className="input-wraper">
                        <span className="input-title">User Id:</span>
                        <input
                          {...register("userId")}
                          className={`input-field  ${errors.userId ? "is-invalid" : ""}`}
                          maxLength={20}
                          placeholder="User Id......"
                        />
                        <div className="invalid-feedback error">
                          {errors.userId?.message}
                        </div>
                      </div>
                      <div className="input-wraper">
                        <span className="input-title">Password:</span>
                        <input
                          {...register("password")}
                          className={`input-field  ${errors.password ? "is-invalid" : ""}`}
                          maxLength={20}
                          placeholder="Password....."
                        />
                        <div className="invalid-feedback error">
                          {errors.password?.message}
                        </div>
                      </div>
                    </div>
                    <div className="input-left">
                      <div className="input-wraper">
                        <span className="input-title">Phone Number:</span>
                        <input
                          {...register("phNumber")}
                          className={`input-field  ${errors.phNumber ? "is-invalid" : ""}`}
                          onKeyPress={(e) => mobileVal(e)}
                          maxLength={10}
                          placeholder="Phone Number......"
                        />
                        <div className="invalid-feedback error">
                          {errors.phNumber?.message}
                        </div>
                      </div>
                      <div className="input-wraper">
                        <span className="input-title">Team Lead:</span>
                        <input
                          {...register("teamlead")}
                          className={`input-field  ${errors.teamlead ? "is-invalid" : ""}`}
                          onInput={(e) => nameValidation(e)}
                          maxLength={50}
                          placeholder="Team Lead....."
                        />
                        <div className="invalid-feedback error">
                          {errors.teamlead?.message}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {editType === "personal" && (
                  <>
                    <div className="edit-input personal">
                      <div className="input-wraper">
                        <span className="input-title">Full Name:</span>
                        <input
                          {...register("fullName")}
                          className={`input-field ${errors.fullName ? "is-invalid" : ""}`}
                          maxLength={50}
                          placeholder="Full Name......"
                        />
                        <div className="invalid-feedback error">
                          {errors.fullName?.message}
                        </div>
                      </div>
                      <div className="input-wraper">
                        <span className="input-title">DOB:</span>
                        <input
                          {...register("dob")}
                          className={`input-field ${errors.dob ? "is-invalid" : ""}`}
                          maxLength={10}
                          placeholder="DOB......"
                        />
                        <div className="invalid-feedback error">
                          {errors.dob?.message}
                        </div>
                      </div>
                      <div className="input-wraper">
                        <span className="input-title">Gender:</span>
                        <input
                          {...register("gender")}
                          className={`input-field ${errors.gender ? "is-invalid" : ""}`}
                          maxLength={10}
                          placeholder="Gender......"
                        />
                        <div className="invalid-feedback error">
                          {errors.gender?.message}
                        </div>
                      </div>
                    </div>
                    <div className="edit-input personal">

                      <div className="input-wraper">
                        <span className="input-title">Address:</span>
                        <input
                          {...register("address")}
                          className={`input-field ${errors.address ? "is-invalid" : ""}`}
                          maxLength={100}
                          placeholder="Address......"
                        />
                        <div className="invalid-feedback error">
                          {errors.address?.message}
                        </div>
                      </div>
                      <div className="input-wraper">
                        <span className="input-title">Aadhaar:</span>
                        <input
                          {...register("aadhaar")}
                          className={`input-field ${errors.aadhaar ? "is-invalid" : ""}`}
                          maxLength={12}
                          placeholder="Aadhaar......"
                        />
                        <div className="invalid-feedback error">
                          {errors.aadhaar?.message}
                        </div>
                      </div>
                      <div className="input-wraper">
                        <span className="input-title">PAN:</span>
                        <input
                          {...register("pan")}
                          className={`input-field ${errors.pan ? "is-invalid" : ""}`}
                          maxLength={10}
                          placeholder="PAN......"
                        />
                        <div className="invalid-feedback error">
                          {errors.pan?.message}
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {editType === "bank" && (
                  <div className="bank-modal">
                    <div className="bank">
                      <div className="edit-input personal">
                        <div className="input-wraper">
                          <span className="input-title">Account Number:</span>
                          <input
                            {...register("accountNumber")}
                            className={`input-field ${errors.accountNumber ? "is-invalid" : ""}`}
                            maxLength={20}
                            placeholder="Account Number......"
                          />
                          <div className="invalid-feedback error">
                            {errors.accountNumber?.message}
                          </div>
                        </div>
                        <div className="input-wraper">
                          <span className="input-title">IFSC Code:</span>
                          <input
                            {...register("ifscCode")}
                            className={`input-field ${errors.ifscCode ? "is-invalid" : ""}`}
                            maxLength={11}
                            placeholder="IFSC Code......"
                          />
                          <div className="invalid-feedback error">
                            {errors.ifscCode?.message}
                          </div>
                        </div>

                      </div>
                      <div className="edit-input personal">
                        <div className="input-wraper">
                          <span className="input-title">MICR:</span>
                          <input
                            {...register("micr")}
                            className={`input-field ${errors.micr ? "is-invalid" : ""}`}
                            maxLength={9}
                            placeholder="MICR......"
                          />
                          <div className="invalid-feedback error">
                            {errors.micr?.message}
                          </div>
                        </div>
                        <div className="input-wraper">
                          <span className="input-title">Branch Name:</span>
                          <input
                            {...register("branchName")}
                            className={`input-field ${errors.branchName ? "is-invalid" : ""}`}
                            maxLength={50}
                            placeholder="Branch Name......"
                          />
                          <div className="invalid-feedback error">
                            {errors.branchName?.message}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="input-wraper branch">
                      <span className="input-title branch-title">Address:</span>
                      <input
                        {...register("bankaddress")}
                        className={`input-field ${errors.bankaddress ? "is-invalid" : ""}`}
                        maxLength={50}
                        placeholder="Branch Name......"
                      />
                      <div className="invalid-feedback error">
                        {errors.bankaddress?.message}
                      </div>
                    </div>
                  </div>

                )}

              </div>
            </div>
            <div className="btn-yes-no mt-2 mb-6 modal-button">
              <Button
                className="no-btn confirm-btn mr-4"
                onClick={() => setModalHide(false)}
              >
                Cancel
              </Button>
              <Button
                className="yes-btn confirm-btn"
                type="submit"

              // onClick={onFormSubmit}
              >
                Save
              </Button>
            </div>
          </form>
        </Modal.Body>
        {/* <Modal.Footer>
         
          </Modal.Footer> */}
      </Modal>

    </div>
  );
}

export default IBAAgentModalCommon;
